
import {defineComponent, PropType} from 'vue';

export default defineComponent({
  props: {
    cancelLabel: {
      default: 'Annuleren',
      required: false,
      type: [Boolean, String] as PropType<false | string>,
      validator(value: boolean | string) {
        return value === false || typeof value === 'string';
      },
    },
    text: {
      default: undefined,
      required: false,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    value: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
  },

  emits: ['close', 'input'],

  methods: {
    close() {
      this.$emit('input', false);
      this.$emit('close');
    },
  },
});
